import { Image, Page, Text, View } from "@react-pdf/renderer";
import config from "../../../../config";
import { PdfRichText } from "./renderPdfRichText";
import { styles } from "./physicalComponentPdfStyles";
import { PhysicalPdfLabels, PhysicalPdfOrderSummary } from "./types";

interface OrderSummaryPageProps {
	summary: PhysicalPdfOrderSummary;
	labels: PhysicalPdfLabels;
}

const OrderSummaryPage = ({ summary, labels }: OrderSummaryPageProps) => {
	const instructions = [
		labels.physicalPdfInstruction1,
		labels.physicalPdfInstruction2,
		labels.physicalPdfInstruction3,
		labels.physicalPdfInstruction4,
		labels.physicalPdfInstruction5,
	].filter(Boolean);

	return (
		<Page size="A4" style={styles.page}>
			<View
				style={{
					...styles.flexRow,
					...styles.justifyBetween,
					...styles.itemsCenter,
					...styles.mb1,
				}}
			>
				<Image style={styles.logo} src={config.assets.logos.localPng} />
				<View style={{ ...styles.flexCol, alignItems: "flex-end" }}>
					<Text style={styles.eyebrow}>{labels.physicalPdfPage1Title}</Text>
					<Text style={styles.orderNumber}>#{summary.orderId}</Text>
				</View>
			</View>

			<View style={styles.summaryTable}>
				<View style={styles.summaryColumnOrderId}>
					<Text style={{ ...styles.smallColumnLabel, ...styles.mbHalf }}>
						{labels.physicalPdfTableHeaderOrderId}
					</Text>
					<Text style={styles.bodyText}>{summary.orderId}</Text>
				</View>
				<View style={styles.summaryColumnVertical}>
					<Text style={{ ...styles.smallColumnLabel, ...styles.mbHalf }}>
						{labels.physicalPdfTableHeaderVertical}
					</Text>
					{summary.verticals.map((vertical) => (
						<Text key={vertical} style={styles.bodyText}>
							{vertical}
						</Text>
					))}
				</View>
				<View style={styles.summaryColumnCategory}>
					<Text style={{ ...styles.smallColumnLabel, ...styles.mbHalf }}>
						{labels.physicalPdfTableHeaderCategories}
					</Text>
					{summary.categories.map((category) => (
						<Text
							key={category}
							style={{ ...styles.bodyText, marginBottom: 4 }}
						>
							{category}
						</Text>
					))}
				</View>
				<View style={styles.summaryColumnEntries}>
					<Text style={{ ...styles.smallColumnLabel, ...styles.mbHalf }}>
						{labels.physicalPdfTableHeaderEntries}
					</Text>
					<Text style={styles.bodyText}>{summary.entryCount} physical</Text>
				</View>
			</View>

			<View style={styles.sectionHeadingRow}>
				<Text style={styles.sectionHeading}>
					{labels.physicalPdfShippingInstructionsTitle}
				</Text>
				<View style={styles.sectionRule} />
			</View>

			{instructions.map((instruction, index) => (
				<View key={index} style={styles.instructionItem}>
					<View style={styles.instructionNumberCol}>
						<Text style={styles.instructionNumber}>{index + 1}.</Text>
					</View>
					<View style={styles.instructionTextCol}>
						<PdfRichText style={styles.instructionText}>
							{instruction}
						</PdfRichText>
					</View>
				</View>
			))}
		</Page>
	);
};

export default OrderSummaryPage;
